var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavouriteUnstarredAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.579 17.368l-6.806 4.157 1.85-7.758L.567 8.58l7.95-.637L11.578.58l3.063 7.364 7.95.637-6.057 5.187 1.85 7.758-6.806-4.157zm0-2.714l3.262 1.992-.887-3.717 2.903-2.486-3.81-.306L11.58 6.61l-1.468 3.528-3.81.306 2.903 2.486-.887 3.717 3.262-1.99v-.002z",
    fill: "#535353"
  })));
}

export default SvgFavouriteUnstarredAlt;